// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"296":"privacy","569":"job","651":"planboard","809":"account","860":"menu"}[chunkId] + "." + {"296":"d3e2a587","569":"3b0c5fdd","651":"fb844f3e","809":"fe474142","860":"9bc9d6ac"}[chunkId] + ".css";
};